module.exports = __webpack_public_path__ + "static/media/RoundedRect_Secondary@2x.46dc8626.png";